import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { t } from 'i18next';
import UpgradeToWaveEssentialEmptyState from './EmptyState';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function UpgradeToWaveEssentialModal({ isOpen, onClose }: Props) {
  return (
    <Modal size="2xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW="50vw">
        <ModalHeader>{t('upgradeToWaveEssential')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <UpgradeToWaveEssentialEmptyState />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

UpgradeToWaveEssentialModal.EmptyView = UpgradeToWaveEssentialEmptyState;
